import React from 'react'
import { MVPButton, MVPButtonProps } from '../../Buttons/MVPButton'
import ProfileMenu from './ProfileMenu'
import ProfileImage from '../../ProfileImage'
import './ProfileButton.scss'

interface Props extends MVPButtonProps
{
	name: string
}
export const ProfileButton = ({ name, ...buttonProps } : Props) =>
{
	return (
		<div id='profile-button-container'>
			<MVPButton id='profile-button' className='clear' {...buttonProps}>
				<ProfileImage alt='profile' />
				<p>{name}</p>
			</MVPButton>
			<ProfileMenu />
		</div>
	)
}
